import React, { Component } from 'react';

export class GameCard extends Component {

  constructor(props) {
      super(props);
      this.startSelectColor = this.startSelectColor.bind(this);
      this.state = {
          word: props.word.toUpperCase(), status: "", clickableCheck: props.clickableCheck, status: "unselected", selectedColor: "",
          getHintingTurnFunc: props.getHintingTurnFunc, yellowMarker: [false, false], colorSelectionReporter: props.colorSelectionReporter
      };
  }

  render() {
      return (
          <div>
              {this.getButtonContent(this.getContentByStatus())}
          </div>
      );
    }

    getContentByStatus() {
        if (this.state.status === "selecting")
            return this.getSelectingColorContent();
        return this.getCardUnselectedContent();
    }

    getCardUnselectedContent() {
        return (
            <table className={ "offgamecard" + this.getCardTableClass() }>
                <tr><td className={"offcardpart1 offcardpart" + this.getPlayerWordPartClass(1) }>
                    {this.state.word}
                </td></tr>
                <tr><td className={"offcardpart" + this.getPlayerWordPartClass(2)}>
                    {this.state.word}
                </td></tr>
            </table>);
    }

    getGuessingTurn() {
        if (this.state.getHintingTurnFunc() == 1) return 2;
        return 1;
    }

    getCardTableClass() {
        if (this.state.status === "selected") {
            switch (this.state.selectedColor) {
                case "green": return " offgreencard";
                case "black": return " offblackcard";
            }
        }

        return "";
    }

    getPlayerWordPartClass(player) {
        if (this.state.yellowMarker[player - 1] && this.state.selectedColor === "yellow")
            return " offyellowcard";
        return "";
    }

    getSelectingColorContent() {
        return (
            <table className="offcardColorSelect">
                <tr className="offcardColorSelect">
                    <td className="offcardColorSelect"><button className="btn offcardColorSelectButton offblackcard" onClick={() => this.selectColor("black")}></button></td>
                    <td className="offcardColorSelect"><button className="btn offcardColorSelectButton offgreencard" onClick={() => this.selectColor("green")}></button></td>
                    <td className="offcardColorSelect"><button className="btn offcardColorSelectButton offyellowcard" onClick={() => this.selectColor("yellow")}></button></td>
                </tr>
            </table>
            );
    }

    selectColor(color) {
        this.setState({ status: "selected", selectedColor: color });
        if (color === "yellow") {
            this.setState({
                yellowMarker: [
                    this.state.yellowMarker[0] || this.getGuessingTurn() == 1,
                    this.state.yellowMarker[1] || this.getGuessingTurn() == 2
                ]
            });
        }
        this.props.stateReporter(color);
    }

    startSelectColor() {
        if (!this.isClickable())
            return;
        this.setState({ status: "selecting" });
        this.state.colorSelectionReporter(this);
    }

    isClickable() {
        if (!this.state.clickableCheck())
            return false;
        if (this.state.status === "unselected")
            return true;
        if (this.state.status === "selected") {
            if (this.state.selectedColor === "yellow") {
                return !this.state.yellowMarker[this.getGuessingTurn()-1];
            }
            return false;
        }
        return false;
    }

    getButtonContent(fixedContent) {
        if (this.isClickable()) {
            return (
                <button className="btn offactiveCardButton" onClick={this.startSelectColor}>
                    {fixedContent}
                </button >
            );
        }

        return fixedContent;
    }
}
